export const GET_GROUP_LIST = 'GET_GROUP_LIST'
export const GET_GROUP_DETAIL = 'GET_GROUP_DETAIL'
export const SET_GROUP_LIST = 'SET_GROUP_LIST'
export const SET_GROUP_DETAIL = 'SET_GROUP_DETAIL'

export const ADD_GROUP_ITEM = 'ADD_GROUP_ITEM'
export const DELETE_GROUP_ITEM = 'DELETE_GROUP_ITEM'
export const UPDATE_GROUP_ITEM = 'UPDATE_GROUP_ITEM'
export const SET_LAST_RESPONSE = 'SET_LAST_RESPONSE'
export const CLEAR_LAST_RESPONSE = 'CLEAR_LAST_RESPONSE'

export const PICK_ITEM = 'PICK_ITEM'

export const CLEAR_GROUP_DATA = 'CLEAR_GROUP_DATA'
